import { createSelector, OutputSelector } from 'reselect'
import { IShipment, IFullStop } from 'types'
import { ISidebarState } from 'apps/booking/types'
import { IStore } from 'apps/booking/utils/reducers'
import { formatCityState, formatStartAtDate } from '../shipmentHelpers'

const selectSidebar = (state: IStore): ISidebarState => state.sidebar
export const selectSidebarShipment = (state: IStore): IShipment | undefined =>
  state.sidebar.data?.shipment
const selectSidebarShipmentFirstPickup = (state: IStore): IFullStop | undefined =>
  state.sidebar.data?.shipment?.stops
    ?.filter(s => s.type === 'pickup')
    .sort((a, b) => a.stopSequence - b.stopSequence)[0]
const selectSidebarShipmentLastDelivery = (state: IStore): IFullStop | undefined =>
  state.sidebar.data?.shipment?.stops
    ?.filter(s => s.type === 'delivery')
    .sort((a, b) => b.stopSequence - a.stopSequence)[0]

interface SelectSidebarState
  extends OutputSelector<
    IStore,
    {
      open: boolean
      loading: boolean
      error?: string
    },
    (
      res: ISidebarState
    ) => {
      open: boolean
      loading: boolean
      error?: string
    }
  > {}
interface SelectActiveRow
  extends OutputSelector<
    IStore,
    { activeRowId?: number },
    (res: ISidebarState) => { activeRowId?: number }
  > {}
interface SelectSidebarShipment
  extends OutputSelector<
    IStore,
    { shipment?: IShipment },
    (res?: IShipment) => { shipment?: IShipment }
  > {}
interface SelectShipmentLaneDateSelector
  extends OutputSelector<
    IStore,
    {
      pickup?: string
      delivery?: string
      date?: string
    },
    (
      res1?: IFullStop,
      res2?: IFullStop
    ) => {
      pickup?: string
      delivery?: string
      date?: string
    }
  > {}

export const sidebarStateSelector: SelectSidebarState = createSelector(
  selectSidebar,
  ({ error, loading, open }) => ({ open, loading, error })
)

export const activeRowIdSelector: SelectActiveRow = createSelector(
  selectSidebar,
  ({ activeRowId }) => ({ activeRowId })
)

export const sidebarShipmentSelector: SelectSidebarShipment = createSelector(
  selectSidebarShipment,
  shipment => ({ shipment })
)

export const sidebarShipmentLaneDateSelector: SelectShipmentLaneDateSelector = createSelector(
  selectSidebarShipmentFirstPickup,
  selectSidebarShipmentLastDelivery,
  (firstPickup, lastDelivery) => ({
    pickup: formatCityState(firstPickup?.facility),
    delivery: formatCityState(lastDelivery?.facility),
    date: formatStartAtDate(firstPickup?.appointment),
  })
)
